import { ReactNode } from 'react';
import { BottomSheet } from 'components/mobile/BottomSheet/BottomSheet';
import styles from './ModernSheet.module.css';

type Props = {
  title: ReactNode;
  close: () => void;
  children: ReactNode;
};

/** A short sheet (as tall as its content) for the modern home's dialogs.
 *  `close` should keep its identity between renders (useCallback). */
export const ModernSheet = ({ title, close, children }: Props) => (
  <BottomSheet title={title} close={close}>
    <div className={styles.content}>{children}</div>
  </BottomSheet>
);
